// @ts-ignore
import React from "react";
import { Check } from "react-feather";
import ReactMarkdown from "react-markdown";
import { IconButton } from "@narmi/design_system";
import useTimeout from "../useTimeout";

const SuccessMessage = ({
  text,
  dismissMessage,
  creationTime,
  notificationType = "success",
  fromQueryParam = false,
}: {
  text: string;
  dismissMessage: () => void;
  creationTime: number;
  notificationType: string;
  fromQueryParam?: boolean;
}) => {
  if (notificationType === "success") {
    useTimeout(dismissMessage, 5000 - (Date.now() - creationTime));
  }
  return (
    <div className="message-content success">
      <Check color="var(--color-successDark)" />
      <span
        className={notificationType === "success" ? "" : "margin--right--l"}
        data-testid="success-message"
      >
        {fromQueryParam ? text : <ReactMarkdown>{text}</ReactMarkdown>}
      </span>
      {notificationType === "dismissible_success" && (
        <IconButton label="Dismiss" kind="plain" name="x" size="xl" onClick={dismissMessage} />
      )}
    </div>
  );
};

export default SuccessMessage;
